module.exports = __webpack_public_path__ + "static/media/rsz_laboral.f27b9d56.jpg";